import ListViewModel from "../../listViewModel";
import type AccountingDocumentCandidateRowResponse from "entities/accountingDocumentCandidateRowResponse";
import AccountingDocumentCandidatesRepository from "repositories/accountingDocumentCandidatesRepository";
import type { interfaces } from "inversify";
import LocalizationService from "services/localizationService";
import EventBus from "../../../services/eventBus";
import SecurityService from "../../../services/securityService";
import { Modules } from "../../../config";

export default class AccountingDocumentCandidateRowsViewModel extends ListViewModel<AccountingDocumentCandidateRowResponse> {
  readonly modelName = "accountingDocumentCandidateRowResponse";

  constructor(
    private itemId: string,
    protected repository: AccountingDocumentCandidatesRepository,
    protected localizationService: LocalizationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = "";
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.getAllRows(this.itemId, { limit, offset });
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.finance, `accountingDocumentsCandidates.${code}`);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) =>
      new AccountingDocumentCandidateRowsViewModel(
        itemId,
        container.get(AccountingDocumentCandidatesRepository),
        container.get(LocalizationService),
        container.get(SecurityService),
        container.get(EventBus)
      );
  }
}
